import http from "../../services/http";

const deleteImagens = async (id) => {
  return await http("post", `v1/imagens/deletar`, { id: id });
};

const addImagem = async (formData) => {
  return await http("post", `v1/imagens/cadastrar`, formData, "multipart/form-data");
};

const getImagem = async (id) => {
  return await http("file", `v1/imagens/carregar_imagem/${id}`, []);
};

export { deleteImagens, addImagem, getImagem };
